export class Stats {
	health:number=0;
	healthPct:number=0;
	defense:number=0;
	defensePct:number=0;
	attack:number=0;
	attackPct:number=0;
	speed:number=0;
	speedPct:number=0;
	effectivenessPct:number=0;
	resistancePct:number=0; 
	critRatePct:number=0;
	critDamagePct:number=0;
	dualPct:number=0;
	
	
	constructor(h:number=0,hP:number=0,d:number=0,dP:number=0,a:number=0,aP:number=0,s:number=0,sP:number=0,e:number=0,r:number=0,cr:number=0,cd:number=0,du:number=0) {
		this.health=h;
		this.healthPct=hP;
		this.defense=d;
		this.defensePct=dP;
		this.attack=a;
		this.attackPct=aP;
		this.speed=s;
		this.effectivenessPct=e;
		this.resistancePct=r; 
		this.critRatePct=cr;
		this.critDamagePct=cd;
		this.dualPct=du;
		this.speedPct=sP;
	}
}